import {
  saveOnboardingData,
  getOnboardingData,
  clearOnboardingData,
} from "@/utils/onboarding-storage";

const useOnboardingStore = (set, get) => ({
  // State
  onboardingData: null,

  // Actions
  initializeOnboarding: () => {
    if (typeof window === "undefined") return;

    const savedData = getOnboardingData();
    if (savedData) {
      set({ onboardingData: savedData });
    }
  },

  updateOnboardingData: (data) => {
    if (typeof window === "undefined") return;

    const currentData = get().onboardingData || {};
    const newData = { ...currentData, ...data };

    // Save to storage
    saveOnboardingData(newData);

    // Update store
    set({ onboardingData: newData });
  },

  clearOnboardingData: () => {
    if (typeof window === "undefined") return;

    // Clear from storage
    clearOnboardingData();

    // Clear from store
    set({ onboardingData: null });
  },

  getOnboardingData: () => {
    return get().onboardingData;
  },
});

export default useOnboardingStore;
